// The tipo of a design or a production line. docs/timber-panel-tipos-proposal.md §3.
//    module: module_unit
//    assembly: the four timber panel types, timber_panel, steel_panel, steel_cage,
//              concrete_slab
//    part: the wrapper part BRANCH (not the category)
//    design of either level: generic, the type of a design nothing typed: no
//              type rule of the company matched its name (Upload detection),
//              no correction of the parsing setup matched, nobody set it
// `subassembly` is set by the analysis only and never offered.

const MODULE_TIPOS = ["module_unit"]

// The four kinds of timber panel. The Planner's element types map one to one
// onto them (exterior_wall, interior_wall, roof_element, floor_element).
const TIMBER_PANEL_TIPOS = ["timber_exterior_wall", "timber_interior_wall", "timber_roof", "timber_floor"]

// A timber panel of none of the four kinds. Valid on designs (every design made
// before the four types existed); never offered on lines, where it is kept
// hidden while old apps are in use (proposal §4.2).
const UNTYPED_TIMBER_PANEL = "timber_panel"

// The type of a design nothing has typed: what a design is created with when
// no type rule of the company matches its name. A design type of both
// levels, never a line type: a line builds real types.
const GENERIC_TIPO = "generic"

const OTHER_ASSEMBLY_TIPOS = ["steel_panel", "steel_cage", "concrete_slab"]

// Every assembly tipo, `timber_panel` included: lines migrated from it still
// carry it, and they must keep reading as production lines.
const ASSEMBLY_TIPOS = [...TIMBER_PANEL_TIPOS, UNTYPED_TIMBER_PANEL, ...OTHER_ASSEMBLY_TIPOS]

const PART_TIPOS = [
    "timber",
    "plate",
    "steel",
    "accesories",
]

// What a line can pick: everything but `timber_panel`.
const LINE_TIPOS = [...MODULE_TIPOS, ...ASSEMBLY_TIPOS, ...PART_TIPOS].filter(t => t !== UNTYPED_TIMBER_PANEL)

// What a type rule can give (the company's by name, the parsing setup's
// corrections): not `generic`, not `timber_panel`.
const RULE_TIPOS = {
    assembly: [...TIMBER_PANEL_TIPOS, ...OTHER_ASSEMBLY_TIPOS],
    module: [...MODULE_TIPOS],
}

// What a design of each level can be set to, `generic` first.
const DESIGN_TIPOS = {
    assembly: [GENERIC_TIPO, ...ASSEMBLY_TIPOS],
    module: [GENERIC_TIPO, ...MODULE_TIPOS],
}

// Production tipos are the ones that go to the assembly/module viewer
const PRODUCTION_TIPOS = [...MODULE_TIPOS, ...ASSEMBLY_TIPOS]
// Logistics tipos are part branches (timber, plate, steel, accesories)
const LOGISTICS_TIPOS = [...PART_TIPOS]

function hasLogisticsTipos(tipos) {
    return tipos.some(t => LOGISTICS_TIPOS.includes(t))
}

function hasProductionTipos(tipos) {
    return tipos.some(t => PRODUCTION_TIPOS.includes(t))
}

function hasOnlyLogisticsTipos(tipos) {
    if (tipos.length === 0) return false
    return tipos.every(t => LOGISTICS_TIPOS.includes(t))
}

/**
 * The tipos a line stores, from the ones its form shows: `timber_panel` is
 * added whenever a timber type is picked and removed when none is, so an app
 * built before the four types still sees a production line (proposal §4.2).
 */
function withHiddenTimberPanel(tipos) {
    const shown = (tipos || []).filter(t => t !== UNTYPED_TIMBER_PANEL)
    if (shown.some(t => TIMBER_PANEL_TIPOS.includes(t))) shown.push(UNTYPED_TIMBER_PANEL)
    return shown
}

/** The level a tipo belongs to: "module", "assembly", "part" or null. */
function tipoLevel(tipo) {
    if (MODULE_TIPOS.includes(tipo)) return "module"
    if (ASSEMBLY_TIPOS.includes(tipo) || tipo === "subassembly") return "assembly"
    if (PART_TIPOS.includes(tipo)) return "part"
    return null
}


export {
    MODULE_TIPOS, ASSEMBLY_TIPOS, PART_TIPOS, PRODUCTION_TIPOS, LOGISTICS_TIPOS,
    TIMBER_PANEL_TIPOS, UNTYPED_TIMBER_PANEL, OTHER_ASSEMBLY_TIPOS, LINE_TIPOS, GENERIC_TIPO, DESIGN_TIPOS, RULE_TIPOS,
    hasLogisticsTipos, hasProductionTipos, hasOnlyLogisticsTipos, withHiddenTimberPanel, tipoLevel,
}
